import { useState, useEffect } from "react";

import Landing from "./Landing";
import AppV4 from "./AppV4";
import AppV3 from "./AppV3";
import Reveal from "./Reveal";
import Atelier from "./Atelier";
import AppV2 from "./AppV2";
import Generator from "./AppV2_may28_new";
import Gallery from "./GalleryV2";
import StudioGPT from "./StudioGPT";
import Corporate from "./Corporate";
import CorporateCreate from "./CorporateCreate";
import Pipeline from "./Pipeline";
import NewConstellation from "./NewConstellation";
import Contribute from "./Contribute";
import ConstellationView from "./ConstellationView";
import PrintCompositor from "./PrintCompositor";
import CrystalLanding from "./CrystalLanding";
import OrderConfirmation from "./OrderConfirmation";
import CrystalViewer3D from "./CrystalViewer3D";
import Experience from "./Experience";

function useRoute() {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return path.replace(/\/+$/, "") || "/";
}

export default function App() {
  const path = useRoute();

  if (path === "/atelier") return <Atelier />;
  if (path === "/gallery") return <Gallery />;
  if (path === "/create")  return <AppV4 />;
  if (path === "/create-v3") return <AppV3 />;
  if (path === "/reveal")  return <Reveal />;
  if (path === "/build")   return <Generator />;
  if (path === "/studio")  return <StudioGPT />;
  if (path === "/corporate") return <Corporate />;
  if (path === "/corporate-create") return <CorporateCreate />;
  if (path === "/pipeline") return <Pipeline />;
  if (path === "/new-constellation") return <NewConstellation />;
  if (path === "/contribute") return <Contribute />;
  if (path === "/constellation") return <ConstellationView />;
  if (path === "/experience") return <Experience />;
  if (path === "/compositor") return <PrintCompositor />;
  if (path === "/poster") return <CrystalLanding />;
  if (path === "/crystal") return <CrystalLanding />;
  if (path === "/confirmation") return <OrderConfirmation />;
  if (path === "/3d") return <CrystalViewer3D />;
  if (path === "/legacy")  return <AppV2 />;
  return <Landing />;
}
